<template>
 <form
     ref="saicform"
    @submit="submitHandler"
    action="" method="post"
    class="form"
  > 
    <div class="form-group">
        <h3 class="form-group-title">联系方式</h3>
        <div class="form-group-cont">
            <div class="form-group-box">
                <label for="">姓名</label>
                <input type="text" name="" id="" value="" placeholder="请输入姓名" v-model="SAICformData.uname" @blur="saic_statistics('惠民购车联系方式','姓名',$event)"/>
                <cube-validator ref="validate0" v-model="validate.uname" :model="SAICformData.uname" :rules="rules.required"></cube-validator>
            </div>
            <div class="form-group-box">
                <label for="">身份证号</label>
                <input type="text" name="" id="" value="" placeholder="请输入身份证号" v-model="SAICformData.uidCard" @blur="saic_statistics('惠民购车联系方式','身份证号',$event)"/>
                <cube-validator ref="validate1" v-model="validate.uidCard" :model="SAICformData.uidCard" :rules="rules.required"></cube-validator>
            </div>
            <div class="form-group-box">
                <label for="">手机号码</label>
                <input type="tel" maxlength="11" name="" id="" value="" placeholder="请输入手机号码" v-model="SAICformData.uphone" @blur="saic_statistics('惠民购车联系方式','手机号码',$event)"/>
                <cube-validator ref="validate2" v-model="validate.uphone" :model="SAICformData.uphone" :rules="rules.phone"></cube-validator>
            </div>
            <div class="form-group-box">
                <label for="">验证码</label>
                <input class="vercode" type="tel" maxlength="6" name="" id="" value="" placeholder="请输入验证码" v-model="SAICformData.uvercode" @blur="saic_statistics('惠民购车联系方式','验证码',$event)"/>
                <GetCallMsg :phoneNumber="SAICformData.uphone" />
                <cube-validator v-model="validate.uvercode" ref="validate3" :model="SAICformData.uvercode" :rules="rules.vercode"></cube-validator>
                <!--<cube-button class="vercode-btn" type="button">获取验证码</cube-button>-->
            </div>
        </div>
    </div>
    
                        
    <div class="form-group">
        <h3 class="form-group-title">购车信息</h3>
        <div class="form-group-cont">
            <div class="form-group-box select-wrap">
                <label for="">购买车型</label>
                <cube-select
                  v-model="SAICformData.vehicleType"
                  class="select_m"
                  placeholder ="请选择车型"
                  @change="saic_statistics('惠民购车购车信息','购买车型','change')"
                  :options="vehicleTypeList">
                </cube-select>
                <cube-validator ref="validate4" v-model="validate.vehicleType" :model="SAICformData.vehicleType" :rules="rules.required" :messages="messages"></cube-validator>
            </div>
            <div class="form-group-box select-wrap">
                <label for="">购买省份</label>
                <cube-select
                  v-model="SAICformData.province"
                  class="select_m"
                  placeholder ="请选择省份"
                  @change="selectProvince('惠民购车购车信息','购买省份','change')"
                  :options="provinceList">
                </cube-select>
                <cube-validator ref="validate5" v-model="validate.province" :model="SAICformData.province" :rules="rules.required" :messages="messages"></cube-validator>
            </div>
            <div class="form-group-box select-wrap">
                <label for="">购买城市</label>
                <cube-select
                  v-model="SAICformData.city"
                  class="select_m"
                  @change="selectCity('惠民购车购车信息','购买城市','change')"
                  :disabled="cityList.length==0"
                  placeholder ="请选择城市"
                  :options="cityList">
                </cube-select>
                <cube-validator ref="validate6" v-model="validate.city" :model="SAICformData.city" :rules="rules.required" :messages="messages"></cube-validator>
            </div>
            <div class="form-group-box select-wrap">
                <label for="">购买经销商</label>
                <cube-select
                  v-model="SAICformData.distributor"
                  class="select_m"
                  placeholder ="请选择经销商"
                  @change="selectdistributor('惠民购车购车信息','购买经销商','change')"
                  :disabled="distributorList.length==0"
                  :options="distributorList">
                </cube-select>
                <!--<cube-validator ref="validate7" v-model="validate.distributor" :model="SAICformData.distributor" :rules="rules.required" :messages="messages"></cube-validator>-->
                <cube-validator ref="validate7" v-model="validate.distributor" :model="SAICformData.distributor" ></cube-validator>
            </div>
            
            <div class="form-group-box select-wrap">
                <label for="">上牌省份</label>
                <cube-select
                  v-model="SAICformData.licenseProvince"
                  class="select_m"
                  placeholder ="请选择上牌省份"
                  @change="selectlicenseProvince('惠民购车购车信息','上牌省份','change')"
                  :options="licenseProvinceList">
                </cube-select>
                <cube-validator ref="validate8" v-model="validate.licenseProvince" :model="SAICformData.licenseProvince" :rules="rules.required" :messages="messages"></cube-validator>
            </div>
            
            <div class="form-group-box select-wrap">
                <label for="">上牌城市</label>
                <cube-select
                  v-model="SAICformData.licenseCity"
                  class="select_m"
                  :disabled="licenseCityList.length==0"
                  @change="selectlicenseCity('惠民购车购车信息','上牌城市','change')"
                  placeholder ="请选择上牌城市"
                  :options="licenseCityList">
                </cube-select>
                <cube-validator ref="validate9" v-model="validate.licenseCity" :model="SAICformData.licenseCity" :rules="rules.required" :messages="messages"></cube-validator>
            </div>
            
            <div class="form-group-box select-wrap">
                <label for="">车架号</label>
                <input type="text" name="" id="" value="" placeholder="请输入车架号" v-model="SAICformData.frameNumber" @blur="saic_statistics('惠民购车购车信息','车架号',$event)"/>
                <cube-validator ref="validate10" v-model="validate.frameNumber" :model="SAICformData.frameNumber" :rules="rules.required"></cube-validator>
            </div>
        </div>
    </div>
                                  
    <div class="form-group upload-wrap">
        <h3 class="form-group-title">上传材料</h3>
        <div class="form-group-cont">
            <div class="form-group-box">
                <label for="">身份证上传</label>
                
                <div class="upload-group">
                    
                    <input type="file" name="" id="" value=""  accept="image/*" @change="addedHandler($event,'idcard')"/>
                    <div class="upload-group-img idcard" v-show="uploadClass.idcard"></div>
                    <div class="upload-group-img idcard-success" v-show="!uploadClass.idcard"></div>
                    
                </div>
                <cube-validator v-model="validate.idcard" ref="validate11" :model="files.idcard" :rules="rules.required" :messages="messagesUpload"></cube-validator>
            </div>
            <div class="form-group-box">
                <label for="">新行驶证上传</label>
                <div class="upload-group">
                    <input type="file" name="" id="" value=""  accept="image/*" @change="addedHandler($event,'license')"/>
                    <div class="upload-group-img driving-license"  v-show="uploadClass.license"></div>
                    <div class="upload-group-img license-success" v-show="!uploadClass.license"></div>
                    
                </div>
                <cube-validator v-model="validate.license" ref="validate12" :model="files.license" :rules="rules.required" :messages="messagesUpload"></cube-validator>
            </div>
            <div class="form-group-box">
                <label for="">旧行驶证或者 (老旧车辆淘汰承诺书)</label>
                <div class="upload-group">
                    <input type="file" name="" id="" value=""  accept="image/*" @change="addedHandler($event,'oldlicense')"/>
                    <div class="upload-group-img driving-license"  v-show="uploadClass.oldlicense"></div>
                    <div class="upload-group-img license-success" v-show="!uploadClass.oldlicense"></div>
                    
                </div>
                <cube-validator v-model="validate.oldlicense" ref="validate13" :model="files.oldlicense" :rules="rules.required" :messages="messagesUpload"></cube-validator>
            </div>
            <div class="form-group-box">
                <label for="">购车发票上传</label>
                <div class="upload-group">
                    <!--<input type="file" name="" id="" value="" />-->
                    <input type="file" name="" id="" value=""  accept="image/*" @change="addedHandler($event,'invoice')"/>
                    <div class="upload-group-img invoice" v-show="uploadClass.invoice"></div>
                    <div class="upload-group-img invoice-success" v-show="!uploadClass.invoice"></div>
                    
                    
                </div>
                <cube-validator v-model="validate.invoice" ref="validate14" :model="files.invoice" :rules="rules.required" :messages="messagesUpload"></cube-validator>
            </div>
            
            <div class="form-group-box">
                <label for="">属地证明材料上传</label>
                <div class="upload-group">
                    <!--<input type="file" name="" id="" value="" />-->
                    <div v-show="!uploadClass.error_place">
                        <input type="file" name="" id="" value=""  accept="image/*" @change="addedHandler($event,'place')"/>
                        <div class="upload-group-img place"  v-show="uploadClass.place"></div>
                        <div class="upload-group-img place-success" v-show="!uploadClass.place"></div>
                    </div>
                    
                    <div class="upload-group-img place-error" v-show="uploadClass.error_place"></div>
                    <div class="upload-group-tips">
                        <span>四选一：居住证（非纸质版暂住证等材料）、有购车人姓名的个体工商营业执照、房产证、社保证明</span>
                    </div>
                </div>
                <cube-validator v-model="validate.place" ref="validate15" :model="files.place" :rules="rules.place" :messages="messagesUpload"></cube-validator>
            </div>
        </div>
    </div>
                        
    <div class="button-box">
    	<cube-button class="submit-btn" @click="submit">完成提交</cube-button>
        <cube-button class="link-btn" type="button" @click="go_Index('惠民购车返回首页','返回首页','click')">返回首页</cube-button>
    </div>
    <div class="preLoadImg">
        <div class="invoice-success"></div>
    	<div class="place-success" ></div>
        <div class="license-success"></div>
        <div class="idcard-success"></div>
    </div>
 </form >
</template>

<script>
    import GetCallMsg from './GetCallMsg';
    import { GAstatisticsMb, uploadCityArr, vehicleTypeListMb, msgUploadObj} from 'SaicUtil'
    import {
        getProvince,
        getCity,
        getDistributor,
        getOSSToken,
        ossUpload,
        submitForm
    } from 'api';
    const vehicleTypeList = vehicleTypeListMb
    const GAstatistics = GAstatisticsMb
    
    
    export default {
        name:'formMb',
        data(){
            return {
                SAICformData: { //提交表单信息
                    uname:'',
                    uidCard: '',
                    uphone: '',
                    uvercode: '',
                    vehicleType: '',
                    province: '',
                    city: '',
	                provinceText: '',
	                cityText: '',
                    distributor: '',
                    distributorText: '',
                    licenseProvince: '',
                    licenseCity: '',
	                licenseProvinceText: '',
	                licenseCityText: '',
                    frameNumber:'',
                    uoloadImgUrl:{
                        idcard: '',
                        license: '',
                        invoice: '',
                        place: '',
                        oldlicense: ''
                    }
                },
                validate: { //表单信息验证
                    uname: undefined,
                    uidCard: undefined,
                    uphone: undefined,
                    uvercode: undefined,
                    vehicleType: undefined,
                    province: undefined,
                    city: undefined,
//                  distributor: undefined,
                    licenseProvince: undefined,
                    licenseCity: undefined,
                    frameNumber:undefined,
                    idcard:undefined,
                    license: undefined,
                    invoice: undefined,
                    place:undefined,
                    oldlicense: undefined
                },
                rules: { //验证规则
                    required: {required: true},
                    phone:{required: true},
                    vercode: {
                        required: true,
                        type: 'number'
                    },
                    place: {
                        required: true
                    }
                },
                messages: { //验证规则提示信息
                    required:'此为必选项'
                },
                messagesUpload: {//验证规则提示信息
                    required:'必须上传图片'
                },
                
                vehicleTypeList: vehicleTypeList, //车型列表
                provinceList: [], //省份列表
                cityList: [],//城市列表
                distributorList: [],//经销商列表
                licenseProvinceList: [],//上牌省份列表
                licenseCityList: [],//上牌城市列表
                action:{ //上传图片路径
                    target:''
                },
                uploadClass:{ //上传状态控制
                    idcard: true,
                    license: true,
                    invoice: true,
                    place:true,
                    oldlicense: true,
                	error_place: false
                },
                files:{ //上传图片内容
                    idcard: [],
                    license: [],
                    invoice: [],
                    place:[],
                    oldlicense: []
                }
            }
        },
        mounted(){
          getProvince().then(data => { //获取省份信息
              this.provinceList = this.get2Array(data)
              this.licenseProvinceList = this.get2Array(data)
          })
        },
        components: {
            GetCallMsg,//验证码模板
        },
        watch:{
            'SAICformData.uvercode':function() { //监听验证码输入
                this.SAICformData.uvercode = this.check_only_num(this.SAICformData.uvercode)
            },
            "SAICformData.uphone": function () { //监听电话号码输入
                this.SAICformData.uphone = this.check_only_num(this.SAICformData.uphone)
            },
            "SAICformData.city": function () {
                this.uploadErrorPlace()
            },
            "SAICformData.province": function () {
                this.uploadErrorPlace()
            },
            "SAICformData.licenseProvince": function () {
                this.uploadErrorPlace()
            }
        },
        methods: {
            go_Index (lbl_category, user_event, lbl_event) { //返回首页
                this.saic_statistics(lbl_category, user_event, lbl_event)
              location.href = 'https://www.roewe.com.cn/'
            },
            uploadErrorPlace () {
                if(this.SAICformData.province && this.SAICformData.city && this.SAICformData.licenseProvince ){
                    if( this.SAICformData.province  !== this.SAICformData.licenseProvince && uploadCityArr.indexOf(this.SAICformData.city)>-1) {
                        this.uploadClass.error_place = false
                        this.rules.place = { required: true }
                    }else{
                        this.uploadClass.error_place = true
                        this.rules.place = { required: false }
                        this.$refs.validate15.validate()
                    }
                }else{
                    this.uploadClass.error_place = false
                    this.rules.place = { required: true }
                }
            },
            saicDialogSuccess () { //表单提交成功提示
                 this.$createDialog({
                    type: 'alert',
                    confirmBtn: {
                      text: '返回首页',
                      active: true,
                      href: 'https://www.roewe.com.cn/'
                    }
                  }, (createElement) => {
                    return [
                      createElement('div', {
                        'class': {
                          'my-title': true
                        },
                        slot: 'title'
                      }, [
                        createElement('div', {
                          'class': {
                            'success-img': true
                          }
                        })
                      ]),
                      createElement('p', {
                        'class': {
                          'success-dialog-cont': true
                        },
                        slot: 'content'
                      }, '提交成功')
                    ]
                  }).show()
            },
            saicDialogfault(msg) { //表单提交失败提示
                this.$createDialog({
                    type: 'alert',
                    confirmBtn: {
                      text: '关闭',
                      active: true
                    }
                  }, (createElement) => {
                    return [
                      createElement('div', {
                        'class': {
                          'my-title': true
                        },
                        slot: 'title'
                      }, [
                        createElement('div', {
                          'class': {
                            'fault-img': true
                          }
                        })
                      ]),
                      createElement('p', {
                        'class': {
                          'fault-dialog-cont': true
                        },
                        slot: 'content'
                      }, msg)
                    ]
                }).show()
            },
            check_only_num: function(val) { //纯数字校验
                return val.replace(/\D/g, '');
            },
            saic_statistics(a,b,e) { //统计代码
                if(typeof e === 'string'){
                    e = {
                        type:e
                    }
                }
                GAstatistics(a,e.type,b)
            },
            uploadImgSimple (files, type, ossPutFunc) { //图片上传oss处理
                return new Promise((resolve, rej) => {
                        try{
                            ossPutFunc(`/BlueSkyDefense/${+new Date()}${files.name}`,files).then((res) => {
                                if(res.res && res.res.requestUrls){
                                    this.SAICformData.uoloadImgUrl[type] = res.res.requestUrls[0]
                                    resolve()
                                }
                            }).catch(err => {
                                console.log(err)
                                this.saic_statistics('惠民购车上传材料',`${msgUploadObj[type]}上传失败`,'click')
                                this.$createDialog({
                                    type: 'alert',
                                    content: '上传图片失败',
                                    icon: 'cubeic-important'
                                }).show()
                                rej(err)
                            })
                        }catch(e){
                            rej()
                        }
                })
            },
            uploadImgAll(){//所有图片上传
                const _this = this
                return new Promise ((res, rej) => {
                    getOSSToken().then(data => {
                        const oss_config = data.data
                        if(oss_config && oss_config.StatusCode === '200'){
                            return ossUpload({
                                accessKeyId: oss_config.AccessKeyId,
                                accessKeySecret: oss_config.AccessKeySecret,
                                stsToken: oss_config.SecurityToken,
                                region: oss_config.endpoint.split('.')[0],
                                bucket: oss_config.bucketName
                            })
                        }else{
                            this.$createDialog({
                                type: 'alert',
                                content: '获取oss token失败',
                                icon: 'cubeic-important'
                            }).show()
                            rej()
                        }
                    }).then((result) => {
                        if(result){
                            let promiseAllArr = [
                                _this.uploadImgSimple(_this.files['idcard'],'idcard',result),
                                _this.uploadImgSimple(_this.files['license'],'license',result),
                                _this.uploadImgSimple(_this.files['invoice'],'invoice',result),
                                _this.uploadImgSimple(_this.files['oldlicense'],'oldlicense',result)
                            ]
                            if(!_this.uploadClass.error_place){
                                promiseAllArr.push(_this.uploadImgSimple(_this.files['place'],'place',result))
                            }
                            Promise.all(promiseAllArr).then(() => {
//                              console.log(_this.SAICformData.uoloadImgUrl)
                                res()
                            }).catch(()=>{
                                this.$createDialog({
                                    type: 'alert',
                                    content: '上传图片失败',
                                    icon: 'cubeic-important'
                                }).show()
                                rej()
                            })
                        }
                    }).catch(() => {rej()})
                })
            },
            get2Array (arr) {//接口数据转换处理
                let realArr = []
                arr.forEach((val, index) => {
                    realArr.push(Object.assign(val,{
                        text: val.name,
                        value: val.id
                    }))
                })
                return realArr
            },
            addedHandler(e,type) {//添加上传的图片 
                const files = e.target.files
                const maxSize = 5 * 1024 * 1024 // 5M
                if (!files.length) return;
                if (files && files.length > 1) {
                    this.$createDialog({
                        type: 'alert',
                        content: '只能上传一张图片',
                        icon: 'cubeic-important'
                    }).show()
                    return
                }
                if(files[0].size > maxSize){
                    this.$createDialog({
                        type: 'alert',
                        content: '上传图片不能超过5M',
                        icon: 'cubeic-important'
                    }).show()
                    return
                }
                this.uploadClass[type] = false
                this.files[type] = files[0]
                this.saic_statistics('惠民购车上传材料', `${msgUploadObj[type]}上传成功`, 'change')
            },
            errHandler(file) { //上传失败处理
              this.$createToast({
                type: 'warn',
                txt: '上传失败',
                time: 1000
              }).show()
            },
	        getText (arr, val) { //获取选择项的显示内容
	        	return arr.find((item)=>{
				     return item.id === val;
			  	}).name
	        },
            selectProvince(lbl_category, user_event, lbl_event) { //省份选择回调
                this.saic_statistics(lbl_category, user_event, lbl_event)
                  if(this.SAICformData.province){
                      this.SAICformData.city = '';
                      this.cityList = [];
                      this.SAICformData.distributor = '';
                      this.distributorList = [];
		                this.SAICformData.provinceText = this.getText(
		                	this.provinceList,
		                	this.SAICformData.province
		                )
                      getCity(this.SAICformData.province).then(data =>{
                          this.cityList = this.get2Array(data)
                      })
                  }
            },
            selectCity(lbl_category, user_event, lbl_event) { //城市选择回调
                this.saic_statistics(lbl_category, user_event, lbl_event)
              if(this.SAICformData.city){
                  this.SAICformData.distributor = '';
                  this.distributorList = [];
	                this.SAICformData.cityText = this.getText(
	                	this.cityList,
	                	this.SAICformData.city
	                )
                  getDistributor(this.SAICformData.city).then(data =>{
                      this.distributorList = this.get2Array(data)
                  })
              }
            },
            selectlicenseProvince (lbl_category, user_event, lbl_event) { //上牌省份选择回调
                this.saic_statistics(lbl_category, user_event, lbl_event)
              if(this.SAICformData.licenseProvince){
                  this.SAICformData.licenseCity = '';
                  this.licenseCityList = [];
                this.SAICformData.licenseProvinceText = this.getText(
                	this.licenseProvinceList,
                	this.SAICformData.licenseProvince
                )
                  getCity(this.SAICformData.licenseProvince).then(data =>{
                      this.licenseCityList = this.get2Array(data)
                  })
              }
            },
        selectlicenseCity(lbl_category, user_event, lbl_event){ //上牌城市选择回调
            this.saic_statistics(lbl_category, user_event, lbl_event)
            if(this.SAICformData.licenseCity) {
                this.SAICformData.licenseCityText = this.getText(
                	this.licenseCityList,
                	this.SAICformData.licenseCity
                )
            }
        },
        selectdistributor(lbl_category, user_event, lbl_event){//经销商选择回调
          this.saic_statistics(lbl_category, user_event, lbl_event)
          if(this.SAICformData.distributor) {
              this.SAICformData.distributorText = this.getText(
                this.distributorList,
                this.SAICformData.distributor
              )
          }
        },
             submitHandler(e) { //表单验证通过后提交表单内容
                const toast = this.$createToast({
                    txt: '信息提交中...',
                    mask: true,
                    time: 600000
                  })
                  toast.show()
                this.uploadImgAll().then(() => {
                    var fd = new FormData()
                    fd.append('userName', this.SAICformData.uname)
                    fd.append('mobile', this.SAICformData.uphone)
                    fd.append('cardNo', this.SAICformData.uidCard)
                    fd.append('dealerCode ', this.SAICformData.distributor)
                    fd.append('dealerName ', this.SAICformData.distributor ? this.SAICformData.distributorText : '')
                    fd.append('vehicle', this.SAICformData.vehicleType)
                    fd.append('buyProvince', this.SAICformData.provinceText)
                    fd.append('buyCity', this.SAICformData.cityText)
                    fd.append('upperProvince', this.SAICformData.licenseProvinceText)
                    fd.append('upperCity', this.SAICformData.licenseCityText)
                    fd.append('buyProvinceId', this.SAICformData.province)
                    fd.append('buyCityId', this.SAICformData.city)
                    fd.append('upperProvinceId', this.SAICformData.licenseProvince)
                    fd.append('upperCityId', this.SAICformData.licenseCity)
                    fd.append('vin', this.SAICformData.frameNumber)
                    fd.append('cardUrl', this.SAICformData.uoloadImgUrl.idcard)
                    fd.append('oldDrivingUrl', this.SAICformData.uoloadImgUrl.oldlicense)
                    fd.append('newDrivingUrl', this.SAICformData.uoloadImgUrl.license)
                    fd.append('carInvoice', this.SAICformData.uoloadImgUrl.invoice)
                    fd.append('dependentCert', this.uploadClass.error_place?'':this.SAICformData.uoloadImgUrl.place)
                    fd.append('smsCode', this.SAICformData.uvercode)
                    
                    submitForm(fd).then(data => {
                        toast.hide()
                        try{
                            if(data.data && data.data.code === '200'){
                                this.saicDialogSuccess()
                                this.saic_statistics('惠民购车完成提交','完成提交成功','click')
                            }else if(data.err_resp){
                                this.saic_statistics('惠民购车完成提交','完成提交失败','click')
                                this.saicDialogfault(data.err_resp.msg)
                            }
                        }catch(e){
                            this.saic_statistics('惠民购车完成提交','完成提交失败','click')
                            this.saicDialogfault('提交失败')
                            //TODO handle the exception
                        }
                    }).catch(() => { toast.hide() })
                }).catch(() => { toast.hide() })
            },
            validateHandler(result) {
              this.validity = result.validity
              this.valid = result.valid
            },
            submit () { //点击提交按钮进行表单验证
                const p1 = this.$refs.validate0.validate()
                const p2 = this.$refs.validate1.validate()
                const p3 = this.$refs.validate2.validate()
                const p4 = this.$refs.validate3.validate()
                const p5 = this.$refs.validate4.validate()
                const p6 = this.$refs.validate5.validate()
                const p7 = this.$refs.validate6.validate()
                const p8 = this.$refs.validate7.validate()
                const p9 = this.$refs.validate8.validate()
                const p10 = this.$refs.validate9.validate()
                const p11 = this.$refs.validate10.validate()
                const p12 = this.$refs.validate11.validate()
                const p13 = this.$refs.validate12.validate()
                const p14 = this.$refs.validate13.validate()
                const p15 = this.$refs.validate14.validate()
                
                const self = this
                const validatePromiseArray = [p1, p2, p3, p4, p5, p6, p7, p8, p9, p10, p11, p12, p13, p14, p15]
                //判断限购城市 start
                if( this.uploadClass.error_place) {
	                this.validate.place = true
	                this.rules.place = { required: false }
	                this.$refs.validate15.validate()
	            } else {
	            	const p16 = this.$refs.validate15.validate()
	                validatePromiseArray.push(p16)
	                this.rules.place = { required: true }
	            }
                //end
                
                
                //表单全部验证成功处理函数
                Promise.all([validatePromiseArray]).then(() => {
                    if(Object.values(this.validate).every(item => item)) {
                        self.submitHandler()
                    } else {
                        this.$createDialog({
                            type: 'alert',
                            content: '信息填写错误',
                            icon: 'cubeic-important'
                        }).show()
                    }
                }).catch(() => {})
            }
        }
    }
</script>

<style  lang="scss">
@import "~@/assets/scss/mb.scss"
</style>